import React, { useState } from "react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import LoginPage from "./pages/LoginPage";
import AdminPage from "./pages/AdminPage";
import CustomerPage from "./pages/CustomerPage";
import SettingsPage from "./components/SettingsPage";
import { Spinner } from "./components/UI";
import "./App.css";

function AppRouter() {
  const { user, loading } = useAuth();
  const [showSettings, setShowSettings] = useState(false);

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Spinner msg="Loading LebMarket..." />
      </div>
    );
  }

  if (!user) return <LoginPage />;

  if (showSettings && user.role === "customer") {
    return (
      <>
        <Navbar inSettings onSettings={() => setShowSettings(false)} />
        <SettingsPage user={user} onUpdated={() => setShowSettings(false)} />
      </>
    );
  }

  return (
    <>
      <Navbar onSettings={() => setShowSettings(true)} />
      {user.role === "admin" ? <AdminPage /> : <CustomerPage />}
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}
